import styled from "styled-components";
import { Box, Toolbar, List, Select } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  box-shadow: 0 4px 24px 0 rgb(0 0 0 / 35%);
  padding-top: 0px;
  padding-bottom: 0px;
  transition: all 0.3s ease;
  background-color: ${({ theme }) =>
    theme.palette.background.sidebarBackground};
`;

export const MyToolbar = styled(Toolbar)`
  justify-content: space-between;
  height: 48px;
  min-height: 32px !important;
  padding: 0px !important;
`;

export const CategoryBox = styled.div`
  margin-bottom: 16px;
  padding: 16px;

  .category-title {
    font-size: 1.1rem;
    font-weight: 500;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .tiles-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    gap: 12px;
    justify-items: center;
  }
`;

export const TileButton = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90px;
  padding: 8px 6px;
  border-radius: 16px;
  background-color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(255, 255, 255, 0.5)"};
  border: 1px solid
    ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.1)"};
  position: relative;

  &:active {
    background-color: ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.08)"};
    transform: scale(0.97);
    transition: transform 0.1s ease-in-out;
  }

  .tile-text-container {
    flex: 1;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .tile-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin-bottom: 4px;
  }

  .tile-text {
    font-size: 0.6rem;
    line-height: 1.2;
    padding: 4px 0;
    width: 100%;
    word-wrap: break-word;
    text-align: center;
    font-weight: 500;
  }
`;

export const DrawerContent = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 0.4em;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(0, 0, 0, 0.2)"};
    border-radius: 16px;
  }
`;

export const BottomMenu = styled(List)`
  margin-top: auto;
  border-top: 1px solid
    ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.1)"};
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .list-items {
    flex: 1;
  }

  .MuiListItem-root {
    border-radius: 12px;
    margin-bottom: 4px;
    padding: 16px;

    &:active {
      background-color: ${({ theme }) =>
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.15)"
          : "rgba(0, 0, 0, 0.08)"};
    }
  }

  .MuiListItemIcon-root {
    min-width: 40px;
  }

  img {
    margin-right: 16px;
  }
`;

export const SettingsContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 12px;
  margin-top: 2rem;
  border: 1px solid
    ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.1)"};
  background-color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(255, 255, 255, 0.5)"};
`;

export const LanguageSelect = muiStyled(Select)`
  width: 120px;
  height: 32px;
  border: none;
  background-color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(255, 255, 255, 0.5)"};
  
  & .MuiSelect-select {
    padding: 4px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: inherit;
    
    &:focus {
      background-color: transparent;
    }
  }
  
  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.1)"};
  }
  
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.2)"
        : "rgba(0, 0, 0, 0.2)"};
  }
  
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) =>
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.2)"
        : "rgba(0, 0, 0, 0.2)"};
  }
`;
